module.exports = __webpack_public_path__ + "img/pixing_xc3.208e8ab3.jpg";